import { render, staticRenderFns } from "./newAdd.vue?vue&type=template&id=1b2e28bf&scoped=true"
import script from "./newAdd.vue?vue&type=script&lang=js"
export * from "./newAdd.vue?vue&type=script&lang=js"
import style0 from "./newAdd.vue?vue&type=style&index=0&id=1b2e28bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2e28bf",
  null
  
)

export default component.exports